// frontend/src/services/dashboardService.js
import api from './api';

export const getDashboardStats = async (classId) => {
    try {
        const response = await api.get('/dashboard/stats', {
            params: { classId }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching dashboard stats:", error);
        throw error;
    }
};